/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetEnabledRequestBody,
  SetEnabledRequestBody$Outbound,
  SetEnabledRequestBody$outboundSchema,
} from "../components/setenabledrequestbody.js";

export type SetInternalSessionIssuerEnabledSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetInternalSessionIssuerEnabledRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setEnabledRequestBody: SetEnabledRequestBody;
};

/** @internal */
export type SetInternalSessionIssuerEnabledSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetInternalSessionIssuerEnabledSecurity$outboundSchema:
  z.ZodMiniType<
    SetInternalSessionIssuerEnabledSecurity$Outbound,
    SetInternalSessionIssuerEnabledSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setInternalSessionIssuerEnabledSecurityToJSON(
  setInternalSessionIssuerEnabledSecurity:
    SetInternalSessionIssuerEnabledSecurity,
): string {
  return JSON.stringify(
    SetInternalSessionIssuerEnabledSecurity$outboundSchema.parse(
      setInternalSessionIssuerEnabledSecurity,
    ),
  );
}

/** @internal */
export type SetInternalSessionIssuerEnabledRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetEnabledRequestBody: SetEnabledRequestBody$Outbound;
};

/** @internal */
export const SetInternalSessionIssuerEnabledRequest$outboundSchema:
  z.ZodMiniType<
    SetInternalSessionIssuerEnabledRequest$Outbound,
    SetInternalSessionIssuerEnabledRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      setEnabledRequestBody: SetEnabledRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        setEnabledRequestBody: "SetEnabledRequestBody",
      });
    }),
  );

export function setInternalSessionIssuerEnabledRequestToJSON(
  setInternalSessionIssuerEnabledRequest:
    SetInternalSessionIssuerEnabledRequest,
): string {
  return JSON.stringify(
    SetInternalSessionIssuerEnabledRequest$outboundSchema.parse(
      setInternalSessionIssuerEnabledRequest,
    ),
  );
}
